<template>
  <button @click="toggleTheme" class="theme-toggle"
    :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
    :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'">
    <!-- Moon icon for dark mode -->
    <svg v-if="isDark" class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

    <!-- Sun icon for light mode -->
    <svg v-else class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <circle cx="12" cy="12" r="5" stroke-width="2" />
      <line x1="12" y1="1" x2="12" y2="3" stroke-width="2" stroke-linecap="round" />
      <line x1="12" y1="21" x2="12" y2="23" stroke-width="2" stroke-linecap="round" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" stroke-width="2" stroke-linecap="round" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" stroke-width="2" stroke-linecap="round" />
      <line x1="1" y1="12" x2="3" y2="12" stroke-width="2" stroke-linecap="round" />
      <line x1="21" y1="12" x2="23" y2="12" stroke-width="2" stroke-linecap="round" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" stroke-width="2" stroke-linecap="round" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>
</template>

<script>
import { themeMixin } from '@/mixins/themeMixin';

export default {
  name: 'ThemeToggle',
  mixins: [themeMixin]
};
</script>

<style scoped>
.theme-toggle {
  padding: 0px 0px 0px 20px;
  border: none;
  border-radius: 0;
  /* background: var(--bg-primary); */
  background: none !important;
  box-shadow: none !important;
  color: var(--btn-primary-bg);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
}

.theme-toggle:hover {
  transform: scale(1.1);
}

.theme-toggle:active {
  transform: scale(0.95);
}


.icon {
  width: 1.5rem;
  height: 1.5rem;
}
</style>